import React from 'react';
import ShowOnlyPendingRequestsCheckbox from '../../../views/pages/manage/unAssigned/studentFinanceApproval/paymodeApproval/ShowOnlyPendingRequestsCheckbox';
import AMultiFieldSearchInput from '../../../components/AMultiFieldSearchInput/AMultiFieldSearchInput';
import { searchInputOptions } from '../components/searchStudent/studentTransfersListing/utils';
import { statusFilterOptions } from './utils';
import AFilterForm from '../../../components/AFilterForm/AFilterForm';
import { EMPTY_FILTER_FORM, getFilterFormFields } from './utils';

const Filters = ({
    dropdowns,
    filterForm,
    getApprovalRequests,
    loading,
    handleFilterForm
}) => {

    const searchHandler = (filters = {}) => {
        getApprovalRequests({
        filters : {...filterForm, ...filters},
        pageNo : 0
    })
}


    return ( 
        <div className='d-flex' style={{gap : '0.75rem'}}>

            <ShowOnlyPendingRequestsCheckbox
            checked={filterForm?.approvalStatus?.label === 'Pending'}
            showOnlyPendingRequestsHandler={checked => {
                searchHandler({
                    approvalStatus : checked ? statusFilterOptions[1] : []  
                })
            }}
            />

            <AMultiFieldSearchInput
            options={searchInputOptions}
            isLoading={loading}
            searchHandler={(keyName, value) => searchHandler({[keyName] : value})}
            crossHandler={(keyName, value) => searchHandler({[keyName] : value})}
            />

            <AFilterForm
            formFields={getFilterFormFields(dropdowns, filterForm)}
            filterForm={filterForm}
            handleFilterForm={handleFilterForm}
            applyFilterHandler={searchHandler}
            removeFilterHandler={() => searchHandler(EMPTY_FILTER_FORM)}
            />
        </div>
     );
}
 
export default Filters;